import isNil from 'lodash-es/isNil'

import { useTimeZone } from '../../../../../../hooks'
import { useCalendarGridPointerSelection } from '../../../../CalendarGrid.hooks'

import {
  getCalendarGridWeekAllDayNextSelection,
  getCalendarGridWeekAllDaySelectionDays,
  getIsCalendarGridWeekAllDaySelected,
} from './useCalendarGridWeekAllDaySelection.utils'

export function useCalendarGridWeekAllDaySelection({ days, onSelectDays }) {
  const timezone = useTimeZone()

  // A click without a drag selects its own day (CAL-02 §7.3 rule 5)
  function handlePointerUp(lastSelection) {
    onSelectDays(
      getCalendarGridWeekAllDaySelectionDays({
        days,
        selection: lastSelection,
        timezone,
      })
    )
  }

  const { selection, updateSelection } = useCalendarGridPointerSelection({
    onPointerUp: handlePointerUp,
  })

  function handlePointerDownDay(dayIndex) {
    updateSelection(() => ({ anchor: dayIndex, focus: dayIndex }))
  }

  function handlePointerEnterDay(dayIndex) {
    updateSelection(prevSelection =>
      getCalendarGridWeekAllDayNextSelection({
        dayIndex,
        selection: prevSelection,
      })
    )
  }

  function getIsDaySelected(dayIndex) {
    return getIsCalendarGridWeekAllDaySelected({ dayIndex, selection })
  }

  return {
    getIsDaySelected,
    handlePointerDownDay,
    handlePointerEnterDay,
    isSelecting: !isNil(selection),
  }
}
